$(document).ready(function() {
  $(".si-tab__menu").click(function() {
    var targetId = $(this).attr("data-target")
    $(this).siblings().removeClass("si-tab__menu--active");
    $(this).addClass("si-tab__menu--active");
    $(targetId).siblings("[role='tabpanel']").removeClass("si-tab__panel--active");
    $(targetId + "[role='tabpanel']").addClass("si-tab__panel--active");
  });
});